import styled from 'styled-components'

export const NavbarBackButtonItem = styled.div`
  margin: 0 8px 0 0;
  line-height: 1;
`
